import { contactQuickLinks } from "@/data/resort";
import { cn } from "@/lib/utils";
import { ResortLink } from "../resort-button";
import { Eyebrow, MaskReveal, Reveal } from "../reveal";

export function ContactQuickLinks() {
  return (
    <section aria-labelledby="contact-links-heading" className="bg-secondary/35 py-14 md:py-18">
      <div className="shell">
        <Reveal>
          <Eyebrow>Looking for Something Specific?</Eyebrow>
        </Reveal>
        <h2 id="contact-links-heading" className="display-lg mt-6 max-w-[14ch]">
          <MaskReveal>We Can Help With That</MaskReveal>
        </h2>

        <ul className="mt-8 grid gap-6 md:grid-cols-2">
          {contactQuickLinks.map((card, i) => (
            <li key={card.id}>
              <Reveal delay={i * 0.05}>
                <article
                  className={cn(
                    "flex h-full flex-col border p-7 md:p-8",
                    card.emphasis
                      ? "border-primary bg-primary text-primary-foreground"
                      : "border-border bg-card",
                  )}
                >
                  <h3 className="font-display text-2xl tracking-tight">{card.title}</h3>
                  <p
                    className={cn(
                      "mt-3 flex-1 text-sm leading-relaxed",
                      card.emphasis ? "text-primary-foreground/80" : "text-muted-foreground",
                    )}
                  >
                    {card.copy}
                  </p>
                  <ResortLink
                    variant={card.emphasis ? "gold" : "outline"}
                    href={card.href}
                    className="mt-8 w-full sm:w-auto"
                  >
                    {card.cta}
                  </ResortLink>
                </article>
              </Reveal>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
